export default __webpack_public_path__ + "static/media/carefit-blk.06111aaa.svg";